import * as React from 'react';

import { CoreProps } from 'common/types';
import { Input, Textarea } from 'common/components';
import {
  CoreFormLayout,
  FieldsGrid,
  GridItem,
  Section,
  SectionsWrapper,
} from 'templates/core';
import { TitleInput } from 'templates/details';

import { fields, AuthorsFields, validationSchema } from '../consts';
import { useSave } from '../hooks';

const AuthorsCore = ({
  pk,
  defaultValues,
  children,
  layout = 'overview',
}: CoreProps<AuthorsFields>) => {
  const { save, isSaving, error, created } = useSave(pk);

  if (!pk) {
    layout = 'creation';
  }

  return (
    <>
      <CoreFormLayout
        onSubmit={save}
        defaultValues={defaultValues}
        validationSchema={validationSchema}
        isSubmitting={isSaving}
        error={error}
      >
        {layout === 'overview' && (
          <Section>
            <TitleInput name={fields.name.name} />
          </Section>
        )}
        {layout === 'creation' && (
          <Section>
            <Input name={fields.name.name} label={fields.name.label} />
          </Section>
        )}
        <Section></Section>
        <Section>
          <FieldsGrid>
            <GridItem>
              <Input name={fields.link.name} label={fields.link.label} />
            </GridItem>
            <GridItem>
              <Textarea name={fields.description.name} label={fields.description.label} />
            </GridItem>
          </FieldsGrid>
        </Section>
      </CoreFormLayout>
      <SectionsWrapper pk={created}>{children}</SectionsWrapper>
    </>
  );
};

export default AuthorsCore;
